import { GameData, TutorialStepData } from "./Types";
import * as CardCrawl from "@ravalmatic/cardcrawl-engine";

export class GameVars {

    public static gameData: GameData;
    public static scaleY: number;
    public static isDesktop: boolean;
    public static aspectRatio: number;
    public static gameWidth: number;
    public static gameHeight: number;
    public static currentScene: Phaser.Scene;
    public static intitialised: boolean;
    public static paused: boolean;
    public static cardCrawlEngine: CardCrawl.Engine;
    public static allowedMoves: CardCrawl.AllowedMoves;
    public static gameOver: boolean;
    public static victory: boolean;
    public static f: number;
    public static droppedCardPosition: {x: number, y: number};
    public static specialCardJustUnlocked: boolean;
    public static tutorialMode: boolean;
    public static eventsDispatcher: CardCrawl.EventDispatcher;
    public static tutorialStepData: TutorialStepData;

    public static areValidDomains(domains: string[]): boolean {

        if (domains.length === 0) {
            return true;
        }

        const hostname = window.location.hostname;
        const referrer = document.referrer;

        let isValid = false;

        for (let i = 0; i < domains.length; i++) {
            if (hostname.indexOf(domains[i]) !== -1) {
                isValid = true;
                break;
            }
        }

        if (referrer) {

            isValid = false;
            
            for (let i = 0; i < domains.length; i++) {

                if (referrer.indexOf(domains[i]) !== -1) {
                    isValid = true;
                    break;
                }
            }
        }

        return isValid;
    }

    public static formatNumber(value: number): string {

        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
}
